module.exports = __webpack_public_path__ + "87da7c93615e33c9df975c3bd22c824e.svg";